const Brand = ({ href = "#home" }) => (
  <a href={href} className="nav__brand">
    <span className="nav__mark" aria-hidden="true">
      <span className="nav__spark" />
    </span>
    <span className="nav__name">
      Ant<span className="nav__name-accent">Fire</span> Labs
    </span>
  </a>
);

export default Brand;
